<template>
    <div>
        <v-header />
        <slot></slot>
        <div v-padding="2"></div>
    </div>
</template>
<script>
    import vHeader from './Header';

    export default {
        name: 'sign-layout',
        components: {
            vHeader,
        },
    }
</script>



// WEBPACK FOOTER //
// SignLayout.vue?5ce47f40